// 9fbef606107a605d69c0edbcd8029e5d
import cloneDeep from 'lodash/cloneDeep';
import React, { useRef, useEffect } from 'react';
import { getAPIConfig } from '@tcp/core/src/utils/utils';
import {
  DepartmentsContainer,
  DepartmentTitle,
  Department,
  DepartmentItem,
  DepartmentImageWrapper,
  DepartmentImage,
  DepartmentName,
} from '../styles/DepartmentSelector.style';

export const filterData = (departmentData, hideDepartmentId) => {
  if (hideDepartmentId.length === 0) return departmentData;

  const clonedData = cloneDeep(departmentData);

  const filteredDepartments = clonedData.departments.filter(
    (department) => !hideDepartmentId.includes(department.departmentId)
  );

  return {
    ...clonedData,
    departments: filteredDepartments,
  };
};

const DepartmentSelector = ({
  departmentData,
  activeDepartment,
  onSelectDepartment,
  isQuickView,
}) => {
  const { country } = getAPIConfig();
  const { hideDepartmentIdUS = [], hideDepartmentIdCA = [] } = departmentData;
  const hideColumnName = country === 'US' ? hideDepartmentIdUS : hideDepartmentIdCA;
  const filteredDepartmentsData = filterData(departmentData, hideColumnName);
  const departmentContainerRef = useRef(null);
  const activeRef = useRef(null);

  useEffect(() => {
    if (activeRef.current && departmentContainerRef.current) {
      const container = departmentContainerRef.current;
      const activeElement = activeRef.current;

      const containerRect = container.getBoundingClientRect();
      const activeRect = activeElement.getBoundingClientRect();

      if (activeRect.left < containerRect.left || activeRect.right > containerRect.right) {
        container.scrollTo({
          left:
            activeElement.offsetLeft -
            container.offsetLeft -
            container.clientWidth / 2 +
            activeElement.clientWidth / 2,
          behavior: 'smooth',
        });
      }
    }
  }, [activeDepartment]);

  return (
    <DepartmentsContainer className="dynamic-size-chart-department-section">
      <DepartmentTitle className="department-title-section">
        {filteredDepartmentsData.header}
      </DepartmentTitle>
      <Department
        className="department-image-section"
        ref={departmentContainerRef}
        isQuickView={isQuickView}
      >
        {filteredDepartmentsData.departments.map((department) => (
          <DepartmentItem
            key={`${department.departmentId}_department`}
            id={`${department.departmentId}_department`}
            className={`${
              activeDepartment === department.departmentId
                ? `active_${department.departmentId}_department`
                : `inactive_${department.departmentId}_department`
            }`}
            ref={activeDepartment === department.departmentId ? activeRef : null}
            onClick={() => onSelectDepartment(department.departmentId)}
          >
            <DepartmentImageWrapper active={activeDepartment === department.departmentId}>
              <DepartmentImage
                active={activeDepartment === department.departmentId}
                src={department.url}
                alt={`${department.departmentId}-image`}
                isQuickView={isQuickView}
              />
            </DepartmentImageWrapper>
            <DepartmentName active={activeDepartment === department.departmentId}>
              {department.name}
            </DepartmentName>
          </DepartmentItem>
        ))}
      </Department>
    </DepartmentsContainer>
  );
};

export default DepartmentSelector;
